<!-- 我的页面 -->
<template>
  <div class="h_wrap_con">
    <div class="h_wrap" v-show="returnData.display">
      <!-- 一行一个  -->
      <div
        :class="['imgwrap',returnData.nextDetailsDTOs[0].imgLoaded?'imgloaded':'']"
        @click="showMenuMark('0')"
        @touchmove.stop.prevent="moveHandle"
        v-if="returnData.style=='ONE'"
      >
        <menu-slide
          :ref="['mychild'+componentIndex]"
          :indexw="'0'"
          :showMenu="showMenu"
          :titleColor="returnData.nextDetailsDTOs[0].titleColor"
          v-on:changeMenu2="changeMenu"
          :goodList="returnData.nextDetailsDTOs[0].baseList.length >0? returnData.nextDetailsDTOs[0].baseList :[]"
          :linkUrl="returnData.nextDetailsDTOs[0].linkUrl"
          :newWindows="returnData.nextDetailsDTOs[0].newWindows"
          :menuTitle="returnData.nextDetailsDTOs[0].title"
          :returnData="returnData.nextDetailsDTOs[0].menus"
        ></menu-slide>
        <template v-if="returnData.nextDetailsDTOs[0].urlType=='VIDEO'">
          <div
            v-if="returnData.nextDetailsDTOs[0].urls[0]"
            id="fullParent"
            style="background-color: black"
            class="auto-height"
          >
            <div class="covers"></div>
            <div>
              <video-pc
                :use-video-controller="returnData.nextDetailsDTOs[0].playerControl == 'DISPLAY'"
                :use-b-y-c="returnData.nextDetailsDTOs[0].useBYC"
                :source-url="returnData.nextDetailsDTOs[0].urls[returnData.nextDetailsDTOs[0].urls.length-1]"
                :component-index="componentIndex"
              ></video-pc>
            </div>
            <!-- <blinds v-if="returnData.nextDetailsDTOs[0].useBYC" /> -->
          </div>

          <div class="default" v-else>
            <!-- <img src="@/assets/image/tbm/sidebar.png" class="sidebar" /> -->
            <img src="@/assets/image/tbm/defaultsmallicon.png" class="defaultsmallicon" />
          </div>
        </template>
        <template v-if="returnData.nextDetailsDTOs[0].urlType=='IMAGE'">
          <div
            class="auto-height"
            v-if="returnData.nextDetailsDTOs[0].urls[returnData.nextDetailsDTOs[0].urls.length-1]"
          >
            <div class="covers"></div>
            <img
              class="img"
              :src="returnData.nextDetailsDTOs[0].urls[returnData.nextDetailsDTOs[0].urls.length-1]"
            />
            <blinds v-if="returnData.nextDetailsDTOs[0].useBYC" />
          </div>
          <div class="default" v-else>
            <!-- <img src="@/assets/image/tbm/sidebar.png" class="sidebar" /> -->
            <img src="@/assets/image/tbm/defaultsmallicon.png" class="defaultsmallicon" />
          </div>
        </template>
      </div>

      <template v-if="returnData.style=='TWO'">
        <div
          @click="showMenuMark2(indexw)"
          :class="['imgwrap imgwrap_two',item.imgLoaded?'imgloaded':'']"
          v-for="(item, indexw) in returnData.nextDetailsDTOs"
          :key="indexw"
        >
          <menu-slide
            :ref="['mychild'+componentIndex+indexw]"
            :indexw="indexw.toString()"
            :showMenu="showMenu"
            v-on:changeMenu2="changeMenu"
            :goodList="[]"
            :titleColor="item.titleColor"
            :menuTitle="item.title"
            :linkUrl="item.linkUrl"
            :newWindows="item.newWindows"
            :returnData="item.menus"
          ></menu-slide>
          <template v-if="item.urlType=='VIDEO'">
            <div
              class="auto-height auto-height-two"
              v-if="item.urls[returnData.nextDetailsDTOs[0].urls.length-1]"
            >
              <VideoOneLineForTwo
                :use-b-y-c="item.useBYC"
                :component-index="componentIndex"
                :use-video-controller="item.playerControl =='DISPLAY'"
                :data-source="item.urls[item.urls.length-1]"
              ></VideoOneLineForTwo>
            </div>
            <div class="default" v-else>
              <img src="@/assets/image/tbm/defaultsmallicon.png" class="defaultsmallicon" />
            </div>
          </template>
          <template v-if="item.urlType=='IMAGE'">
            <div class="auto-height auto-height-two" v-if="item.urls[item.urls.length-1]">
              <div class="covers"></div>
              <img class="img" :src="item.urls[item.urls.length-1]" />
              <blinds v-if="item.useBYC" />
            </div>

            <div class="default" v-else>
              <img src="@/assets/image/tbm/defaultsmallicon.png" class="defaultsmallicon" />
            </div>
          </template>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》'
import MenuSlide from "./MenuSlide";
import Blinds from "./Blinds";
import VideoMobile from "./VideoMobile";
import VideoPc from "./VideoPc";
import VideoOneLineForTwo from "./VideoOneLineForTwo";
export default {
  name: "HaiBao",
  data() {
    return {
      currentType: "IMAGE",
      isWechatLike: false,
      add: "aa",
      showMenu: true,
      playingVideo: false,
      voiceOff: true,
      currentTimeString: "00:00",
      currentTime: 0,
      totalTimeString: "00:00",
      totalTime: 0,
      timeLineClientX: 0,
      dragging: false,
      fullScreen: false
    };
  },

  // import引入的组件需要注入到对象中才能使用
  components: {
    VideoOneLineForTwo,
    VideoPc,
    VideoMobile,
    MenuSlide,
    Blinds
  },
  props: {
    returnData: {
      type: Object,
      required: false
    },
    componentIndex: {
      type: Number,
      required: true
    }
  },

  // 监控data中的数据变化
  watch: {
    returnData: {
      immediate: true,
      handler(val, oldVal) {},
      deep: true //true 深度监听
    },
    dragging(newVal) {
      if (newVal) {
        this.playingVideo = false;
      } else {
        this.playingVideo = true;
      }
      const playerLive = document.querySelector("video");
      if (this.playingVideo) {
        playerLive.play();
      } else {
        playerLive.pause();
      }
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    setTimeout(() => {
      this.aaa = true;
    }, 500);
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    var that = this;
    this.version = this.$utils.versions();
    if (this.version.u.indexOf("iPhone") > -1) {
      if (this.version.u.indexOf("Safari") == -1) {
        this.isWechatLike = true;
      }
    } else if (this.version.u.indexOf("Mobile") > -1) {
      //安卓
      this.isWechatLike = true;
    }
    if (this.returnData.display) {
      this.loaded(0);
    }

    this.$nextTick(() => {
      const playerLive = document.getElementById(
        "myVideo" + this.componentIndex
      );
      if (!playerLive) {
        return;
      }
      playerLive.addEventListener("loadedmetadata", () => {
        this.totalTime = playerLive.duration;
        this.totalTimeString = this.formatTime(playerLive.duration);
      });
      playerLive.addEventListener("timeupdate", () => {
        this.currentTime = playerLive.currentTime;
        this.currentTimeString = this.formatTime(playerLive.currentTime);
      });
      playerLive.addEventListener("play", () => {
        this.playingVideo = true;
      });
      playerLive.addEventListener("pause", () => {
        this.playingVideo = false;
      });
    });
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
  // 方法集合
  methods: {
    loaded(i) {
      let item = this.returnData.nextDetailsDTOs[i];
      // console.log("item:", item);
      if (item.urlType == "VIDEO") {
        this.currentType = "VIDEO";
        if (this.isWechatLike) {
          this.videoLoadedAfter(i);
        } else {
          this.safairLoadVideo(i, item.urls[0]); //safair上视频监听存在问题所以特殊处理
        }
      } else {
        // let flag = this.$utils.checkIsUpdatetoWebp(this, item.urls[0]);
        this.loadImages(i, item.urls[0]);
      }
    },
    videoLoadedAfter(i) {
      // console.log("视频加载完成:" + this.returnData.nextDetailsDTOs[i]);
      this.$set(this.returnData.nextDetailsDTOs[i], `imgLoaded`, true);
      let comp = this.componentIndex;
      if (i == 0) {
        //第一个组件的第一张加载完成隐藏loading
        this.$emit("loadingFun");
      }
      let count = i + 1;
      if (count < this.returnData.nextDetailsDTOs.length) {
        this.loaded(count);
      }
    },
    safairLoadVideo(i, src) {
      const myvideo = document.createElement("VIDEO");
      // 方法一
      var that = this;
      let image = new Image();
      image.onload = () => {
        let rate = image.width / image.height;
        this.clientHeightForSwiper = window.innerWidth / rate;
        that.videoLoadedAfter(i);
      };
      image.onerror = function() {
       console.log("海报图片加载出错")
       that.videoLoadedAfter(i);
      }  
      if(src .indexOf('lqEs7uG5Ib-GDlTOnLqzxNob-yiV')>-1){
      image.src = this.$store.state.tempCover;
      } else{
      image.src = src + "?vframe/jpg/offset/2";
      }
      // 打印
      myvideo.src = src;
      myvideo.load();
    },

    loadVideo(i, src) {
      console.log("loadVideo:" + i);
      var myvideo = document.createElement("VIDEO");
      // myvideo.setAttribute("autoplay", true);
      // myvideo.setAttribute("muted", true);
      myvideo.addEventListener("canplay", event => {
        console.log("canplay");
        this.videoLoadedAfter(i);
      });
      myvideo.addEventListener("stalled", event => {
        this.videoLoadedAfter(i);
      });
      myvideo.addEventListener("error", event => {
        console.log("视频加载出错啦");
        this.videoLoadedAfter(i);
      });
      myvideo.src = src;
      myvideo.load();
    },
    loadImages(i, imgsec) {
      var that = this;
      let img = new Image();
      img.onload = function() {
        //检测是否支持webp格式
        let flag = that.$utils.checkIsUpdatetoWebp(this, imgsec);
        if (flag) {
          let urls = that.returnData.nextDetailsDTOs[i].urls;
          urls[0] =  that.$utils.replaceImage(urls[0]) + that.$store.state.ossSuffix;
          that.$set(that.returnData.nextDetailsDTOs[i], `urls`, urls);
        }
        // console.log("loadImages:", i);
        let data = that.returnData.nextDetailsDTOs[i];
        let comp = that.componentIndex;
        that.$set(data, `imgLoaded`, true);
        if (i == 0) {
          //第一个组件的第一张加载完成隐藏loading
          that.$emit("loadingFun");
        }
        let count = i + 1;
        if (count < that.returnData.nextDetailsDTOs.length) {
          that.loaded(count);
        }
      };
      img.onerror = function() {
        let data = that.returnData.nextDetailsDTOs[i];
        let comp = that.componentIndex;
        that.$set(data, `imgLoaded`, true);
        if (i == 0) {
          //第一个组件的第一张加载完成隐藏loading
          that.$emit("loadingFun");
        }
        let count = i + 1;
        if (count < that.returnData.nextDetailsDTOs.length) {
          that.loaded(count);
        }
      };
      let imgsec2 = that.returnData.nextDetailsDTOs[i].urls[0];
      let flag = that.$utils.checkIsUpdatetoWebp(this, imgsec2);
      if (flag) {
        img.src =
         that.$utils.replaceImage(that.returnData.nextDetailsDTOs[i].urls[0]) +
          that.$store.state.ossSuffix;
      } else {
        img.src = that.returnData.nextDetailsDTOs[i].urls[0];
      }
    },

    seekMove(event) {
      if (!this.dragging) {
        return;
      }
      let timeLineClientX = this.$refs.time_line.getBoundingClientRect().x;
      let position = event.clientX - timeLineClientX;
      if (position < 0) {
        position = 0;
      }
      const playerLive = document.querySelector("video");
      playerLive.currentTime =
        (this.totalTime * position) / this.$refs.time_line.clientWidth;
    },
    seekEnd(event) {
      this.dragging = false;
    },
    seekStart(event) {
      this.dragging = true;
      let timeLineClientX = this.$refs.time_line.getBoundingClientRect().x;
      let position = event.clientX - timeLineClientX;
      if (position < 0) {
        position = 0;
      }
      const playerLive = document.querySelector("video");
      playerLive.currentTime =
        (this.totalTime * position) / this.$refs.time_line.clientWidth;
    },
    getPlayedWidth() {
      if (this.$refs.time_line) {
        let width =
          this.$refs.time_line.clientWidth *
          (this.currentTime / this.totalTime);
        return width;
      }
      return 0;
    },
    getNotPlayWidth() {
      if (this.$refs.time_line) {
        let width =
          this.$refs.time_line.clientWidth *
          (this.currentTime / this.totalTime);
        return this.$refs.time_line.clientWidth - width;
      }
      return 0;
    },
    formatTime(value) {
      let result = parseInt(value);
      let h =
        Math.floor(result / 3600) < 10
          ? "0" + Math.floor(result / 3600)
          : Math.floor(result / 3600);
      let m =
        Math.floor((result / 60) % 60) < 10
          ? "0" + Math.floor((result / 60) % 60)
          : Math.floor((result / 60) % 60);
      let s =
        Math.floor(result % 60) < 10
          ? "0" + Math.floor(result % 60)
          : Math.floor(result % 60);
      result = `${h}:${m}:${s}`;
      return result;
    },
    playOrPauseClick() {
      const playerLive = document.querySelector("video");
      if (this.playingVideo) {
        playerLive.pause();
      } else {
        playerLive.play();
      }
    },
    voiceOnOrOff() {
      this.voiceOff = !this.voiceOff;
    },
    fullScreenClick() {
      if (document.fullscreenElement) {
        this.fullScreen = true;
      } else {
        this.fullScreen = false;
      }
      let player = document.getElementById("fullParent");
      if (this.fullScreen) {
        this.exitFullScreen();
        this.fullScreen = false;
      } else {
        this.fullScreen = true;
        player.requestFullscreen();
      }
    },
    exitFullScreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    },

    //遮罩层穿透，阻止底部滑动
    moveHandle() {
      return;
    },
    showMenuMark(index) {
      this.$nextTick(() => {
        var myVideo = document.getElementById("myVideo" + this.componentIndex);
        if (myVideo) {
          myVideo.play();
        }
        var ref = this.$refs[`mychild${this.componentIndex}`];
        ref.showMask(index);
      });
    },
    showMenuMark2(index) {
      this.$nextTick(() => {
        this.$refs[`mychild${this.componentIndex}${index}`][0].showMenu = !this
          .$refs[`mychild${this.componentIndex}${index}`][0].showMenu;
      });
    },
    changeMenu(dd) {
      this.showMenu = dd;
    }
  }
};
</script>

<style lang="less" scoped>
//@import url(); 引入公共css类
.h_wrap_con {
  display: flex;
  flex-direction: column;
  position: relative;
}
.h_wrap {
  display: flex;
  padding: 2.5rem 5rem;
  &:first-child video-full-screen {
    // padding-top: 0;
  }
}
.imgwrap {
  width: 100%;
  min-height: 48.5rem;
  height: auto;
  position: relative;
  opacity: 0;
  &.imgloaded {
    opacity: 1;
    transition: opacity 0.3s ease-in-out 0.3s;
  }

  .img,
  .video {
    width: 100%;
    min-height: 100%;
    height: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
  }

  .meauwrap {
    position: absolute;
    top: 24px;
    left: 26px;
    .sidebar {
      width: 33px;
      height: 21px;
      top: 24px;
      left: 26px;
    }
    .meau_title {
      width: 24px;
      display: inline-block;
      line-height: 1;
      margin-left: 28px;
      font-weight: 400;
      color: #ffffff;
      font-size: 12px;
    }
    .meaulist {
      position: relative;
      top: 5rem;
      left: 6.2rem;
      width: auto;
      font-weight: 300;
      color: #ffffff;
      font-size: 2.8rem;
      line-height: 3.6rem;
    }
  }
  .nodefault {
    width: 100%;
    position: relative;
  }
  .default {
    width: 100%;
    min-height: 48.5rem;
    background: #e3f0ff;
    position: relative;

    .defaultsmallicon {
      width: 4.1rem;
      height: 4.1rem;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
    }
  }
}
video::-webkit-media-controls {
  display: none !important;
}

.auto-height {
  display: block;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
  background: center no-repeat #ffffff;
  background-size: contain;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  filter: grayscale(100%);
  &:hover {
    filter: initial;
  }

  .covers {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  img {
    max-width: 100%;
    vertical-align: middle;
    object-fit: cover;
  }
}
.auto-height-two {
  padding-bottom: 112%;
}
.imgwrap_two {
  // overflow: hidden;
  width: 50%;
  // float: left;
  &:first-child {
    margin-right: 2.5rem;
  }
  &:last-child {
    margin-left: 2.5rem;
  }
  .default {
    min-height: 55.2rem;
    height: 100%;
  }
}

.imgwrap_two:nth-child(even) {
  float: right;
}
.img {
  width: 100%;
}

@media screen and (max-width: 1024px) {
  .h_wrap {
    padding: 1.6rem 3rem;
  }
  .imgwrap_two {
    &:first-child {
      margin-right: 1.6rem;
    }
    &:last-child {
      margin-left: 1.6rem;
    }
  }
}
@media screen and (max-width: 768px) {
  .h_wrap {
    padding: 0 2rem 2.8rem;
  }
  .imgwrap {
    // min-height: 34.1rem;
    .video,
    .img {
      // min-height: 34.1rem;
      object-fit: cover;
    }
  }
  .imgwrap_two {
    &:first-child {
      margin-right: 1rem;
    }
    &:last-child {
      margin-left: 1rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/customize/HaiBao.vue